import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { AppSettings, defaults } from '../settings';

@Injectable({
  providedIn: 'root',
})
export class SettingsService {
  private notice$ = new Subject<any>();
  private loadedSubject: BehaviorSubject<boolean>;
  public loadedChanged$: Observable<boolean>;
  private userPreferenceChangedSubject: BehaviorSubject<boolean>;
  public userPreferenceChanged$: Observable<boolean>;

  private options = defaults;

  constructor() {
    this.loadedSubject = new BehaviorSubject<boolean>(false);
    this.loadedChanged$ = this.loadedSubject.asObservable();
    this.userPreferenceChangedSubject = new BehaviorSubject<boolean>(false);
    this.userPreferenceChanged$ = this.userPreferenceChangedSubject.asObservable();
  }

  get notice(): Observable<any> {
    return this.notice$.asObservable();
  }

  getOptions(): AppSettings {
    return this.options;
  }

  setLayout(options?: AppSettings): AppSettings {
    this.options = Object.assign(defaults, options);
    return this.options;
  }

  setLoadedChanged(value: boolean) {
    this.loadedSubject.next(value);
  }

  setNavState(type: string, value: boolean) {
    this.notice$.next({ type, value } as any);
  }

  setUserPreferenceChanged(value: boolean) {
    this.userPreferenceChangedSubject.next(value);
  }
}
